import "../styles/HomeNew.css";

const REASONS = [
  "FBT supports projects locally (Central Illinois) and globally, in places such as India, Haiti, and Belize.",
  "Over 98% of all donated funds go directly to project recipients. All FBT board members volunteer their time and take no salary or compensation of any kind.",
  "All projects are carefully vetted to ensure they align with the FBT mission including the creation of self-sustainability and transparency in how funds are used. FBT does not support political or religious organizations.",
  "All projects require representation by a liaison known personally by at least one member of the board.",
  "All donations are 100% tax deductible.",
];

const IMPACT = [
  { text: "Providing a nutrient supplement to infants in Haiti.", emoji: "🍼" },
  { text: "Creating a safe environment for formerly incarcerated women to help them get back on their feet.", emoji: "🏠" },
  { text: "Supporting a vocational school for individuals with disabilities in India.", emoji: "🎓" },
  { text: "Ensuring that local school children have the things they need to succeed in school.", emoji: "🏫" },
  { text: "Supplying laptops and other school materials for schoolchildren in Belize.", emoji: "💻" },
  { text: "Providing materials and other support to an orphanage in India.", emoji: "❤️" },
];

export default function Donate() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "44svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">Make a Difference Today</p>
            <h1 className="hero__h1">
              Donate to<br />
              <span className="hero__accent">FBT</span>
            </h1>
            <p className="hero__sub">
              Your generous donation changes the world and makes tomorrow better
              for so many people — locally and around the globe.
            </p>
            <div className="hero__ctas">
              <a
                href="https://www.paypal.com/us/fundraiser/charity/3309392"
                target="_blank"
                rel="noopener noreferrer"
                className="cta cta--solid"
              >
                Donate via PayPal
              </a>
              <a href="/donate/zelle" className="cta cta--ghost">Donate via Zelle →</a>
            </div>
          </div>
          <div className="hero__stats">
            <div className="hstat hstat--purple">
              <span className="hstat__n">98%+</span>
              <span className="hstat__l">Goes to Projects</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">100%</span>
              <span className="hstat__l">Tax Deductible</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">$0</span>
              <span className="hstat__l">Board Salaries</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── DONATE BUTTONS ── */}
      <section className="events" style={{ maxWidth: "1000px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Give Now</span>
          <h2 className="sec-h2">Choose Your Path</h2>
          <p className="sec-sub">Every dollar you donate goes directly to the people and projects that need it most.</p>
        </div>

        <div className="events__grid" style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
          <a
            href="https://www.paypal.com/us/fundraiser/charity/3309392"
            target="_blank"
            rel="noopener noreferrer"
            className="ecard card--purple"
          >
            <div className="ecard__icon">💳</div>
            <div className="ecard__img" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "var(--pu-100)", fontSize: "4rem" }}>
              🅿️
            </div>
            <span className="ecard__label">Online Payment</span>
            <h3 className="ecard__name">Donate via PayPal</h3>
            <p className="ecard__desc">Fast, secure, and easy. Pay with your PayPal account or any major credit card.</p>
            <span className="ecard__arrow">Donate now →</span>
          </a>

          <a href="/donate/zelle" className="ecard card--green">
            <div className="ecard__icon">📲</div>
            <div className="ecard__img" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "var(--gn-100)", fontSize: "4rem" }}>
              💸
            </div>
            <span className="ecard__label">Zero Fees</span>
            <h3 className="ecard__name">Donate via Zelle</h3>
            <p className="ecard__desc">100% of your Zelle donation reaches FBT — no processing fees taken out.</p>
            <span className="ecard__arrow">Learn how →</span>
          </a>

          <a
            href="https://www.paypal.com/donate/?hosted_button_id=SMFYNJXBVZCAY"
            target="_blank"
            rel="noopener noreferrer"
            className="ecard card--pink"
          >
            <div className="ecard__icon">🔁</div>
            <div className="ecard__img" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "var(--pk-100)", fontSize: "4rem" }}>
              📅
            </div>
            <span className="ecard__label">Recurring Gift</span>
            <h3 className="ecard__name">Monthly Donation</h3>
            <p className="ecard__desc">Make a lasting impact with a recurring monthly gift — set it once and give all year long.</p>
            <span className="ecard__arrow">Give monthly →</span>
          </a>
        </div>
      </section>

      {/* ── TOP 5 REASONS ── */}
      <section className="local" style={{ background: "var(--off)", maxWidth: "100%", paddingInline: "var(--pad)" }}>
        <div style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
          <div className="sec-hd">
            <span className="sec-eye">Why FBT</span>
            <h2 className="sec-h2">Top 5 Reasons to Donate</h2>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: ".75rem", maxWidth: "700px", marginInline: "auto" }}>
            {REASONS.map((r, i) => (
              <div key={i} className="lcard" style={{ flexDirection: "row", gap: "1rem", alignItems: "flex-start" }}>
                <span style={{
                  flexShrink: 0, width: 32, height: 32, borderRadius: "50%",
                  background: i % 3 === 0 ? "var(--pu-200)" : i % 3 === 1 ? "var(--pk-200)" : "var(--gn-200)",
                  color: i % 3 === 0 ? "var(--pu-700)" : i % 3 === 1 ? "var(--pk-700)" : "var(--gn-700)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: "var(--ff-head)", fontWeight: 800, fontSize: ".8rem",
                }}>
                  {i + 1}
                </span>
                <p style={{ fontSize: ".9rem", color: "var(--muted)", lineHeight: 1.75 }}>
                  {i === 4
                    ? <><a href="/images/base/FBT-501C3.jpg" style={{ color: "var(--pu-500)", fontWeight: 700 }}>All donations are 100% tax deductible.</a></>
                    : r
                  }
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── IMPACT ── */}
      <section className="local" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Your Impact</span>
          <h2 className="sec-h2">Here's How Your Donation Helps</h2>
          <p className="sec-sub">Real projects. Real people. Real change.</p>
        </div>
        <div className="local__grid">
          {IMPACT.map((item, i) => (
            <div key={i} className="lcard" style={{ gap: ".75rem" }}>
              <span style={{ fontSize: "2rem" }}>{item.emoji}</span>
              <p style={{ fontSize: ".88rem", color: "var(--muted)", lineHeight: 1.7 }}>{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── MAIL-IN ── */}
      <div className="quote-band" style={{ background: "linear-gradient(135deg, var(--pu-900), var(--pu-700))" }}>
        <div style={{ maxWidth: "600px", marginInline: "auto" }}>
          <p style={{ fontSize: "1rem", marginBottom: "1rem" }}>
            Contributions may also be sent by mail to:
          </p>
          <p style={{ fontSize: "1.3rem", fontWeight: 800 }}>
            For a Better Tomorrow<br />
            808 S. Eldorado Road, Suite 1<br />
            Bloomington, IL 61704
          </p>
          <p style={{ fontSize: ".85rem", opacity: .7, marginTop: "1rem", fontWeight: 400 }}>
            FBT is a public charity, tax exempt under Section 501(c)(3) of the Internal Revenue Code.{" "}
            <a href="/images/base/FBT-501C3.jpg" style={{ color: "#c4b5fd" }}>
              View 501(c)(3) document ↗
            </a>
          </p>
        </div>
      </div>

    </div>
  );
}